import { css } from 'lit';

export const q1LogItemCardStyles = css`

  :host {
    display: block;
  }
  
  #log-item-card {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: flex-start;
    height: 100%;
    position: relative;
    box-sizing: border-box;

    text-decoration: none;
    color: var(--gray-9);

    padding: 1rem;
    border-radius: 12px;
    overflow: hidden;
    background: white;
    
    border: 1px solid white;

    z-index: 1;
    transition: all 0.2s;
  }


  a#log-item-card:visited {
    color: var(--gray-9);
    text-decoration: none;
  }
  #log-item-card:hover,
  #log-item-card:focus,
  #log-item-card.always-active {
    border-color: var(--gray-3);
  }

  #log-item-card-info {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  #log-item-card-info > .horizontal {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    align-items: center;
    justify-content: flex-start;
    color: var(--gray-6);
    font-weight: 400;
  }

  #headline {
    font-size: 1.2rem;
    line-height: 1.3em;
    font-weight: 600;
    margin: 0;
  }
  @media (min-width: 650px) {
    #headline {
      font-size: 1.3rem;
      line-height: 1.3em;
    }
  }
  @media (min-width: 1000px) {
    #headline {
      font-size: 1.4rem;
      line-height: 1.3em;
    }
  }
  @media (min-width: 1500px) {
    #headline {
      font-size: 1.5rem;
      line-height: 1.3em;
    }
  }

  sl-icon {
    color: var(--gray-6);
  }

  avatar-stack {
    display: flex;
    flex-direction: row;

    --avatar-border-color: white;
  }
  avatar-stack sl-avatar {
    --size: 1.2rem;
  }
  avatar-stack sl-avatar:not(:first-child) {
    margin-left: -0.55rem;
  }
  avatar-stack sl-avatar::part(base) {
    border: 1px solid var(--avatar-border-color);
  }

  #body {
    border-top: 1px solid var(--gray-2);
    margin-top: 0.5rem;
  }


`;
